/**
 * Sidebar entries the sales feature contributes — a contribution file the
 * shell merges into the route registry; nothing self-registers. Permissions
 * are the canonical strings from openapi/generated/route_policy.gen.go.
 */
import { FileText, Receipt, Truck } from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const salesNavEntries: NavEntry[] = [
  {
    path: "/sales/quotes",
    labelKey: "sales.nav.quotes",
    icon: FileText,
    permission: "sales.quote.read",
  },
  {
    path: "/sales/orders",
    labelKey: "sales.nav.orders",
    icon: Receipt,
    permission: "sales.order.read",
  },
  {
    path: "/sales/fulfilments",
    labelKey: "sales.nav.fulfilments",
    icon: Truck,
    permission: "sales.fulfilment.read",
  },
];
